import React from "react";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import styled from "styled-components";

const Container = styled.div`
  width: 100% !important;
  min-height: 300px;
  height: auto;
  margin: 0;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  -webkit-box-shadow: 0 4px 6px -6px #222;
  -moz-box-shadow: 0 4px 6px -6px #222;
  box-shadow: 0 4px 7px -6px #222;
`;

const Right = styled.div`      
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 15px;
`;

const Logo = styled.img`
  max-width: 300px;
  max-height: 300px;
`;

const Left = styled.div`
    width: 50%;     
    object-fit: contain;
    padding: 15px;
`;

const Title = styled.div`
  font-weight: bold;
  font-size: calc(1.3rem + .6vw);
`;

const Text = styled.p`
    font-size: 15px;
    margin-top: 20px;
    color: #525256;    
`;

const Button = styled.button`
  background-color: rgb(5 202 51);
  border-radius: 20px;
  width: 120px;
  padding: 10px;
  border: none;
  color: white;
`;

function GoToWhyEbusLanding() {
    return (
        <Container className='row'>
            <Right className='col-4 d-none d-xl-block d-lg-block'>
                <Logo alt="logo" src={toAbsoluteUrl("./media/landings/Assets/ebus.webp")} />
            </Right>
            <Left className='col-12 col-md-12 col-lg-6'>
                <Title>چرا اتوبوس ایباس؟</Title>
                <Text>
                    سال‌هاست که حمل‌و‌نقل عمومی اتوبوسی در کشور ایران مشغول به فعالیت است و شرکت‌های حمل‌و‌نقل بسیاری در این زمینه فعالیت می‌کنند و باتوجه به تجربه شما در این سال‌ها طبیعی‌ست که برای سفر با اتوبوس به روش سنتی شرکت‌های فعلی را برای سفر انتخاب کنید. اما! برای پاسخ به چرایی سوالات احتمالی شما باید بدانید که ایباس برای یک تغییر، با تیمی جوان به روی‌کار‌آمده تا تغییراتی در جزئیات سفر ایجاد کند، جزئیاتی که می تواند کیفیت  شما رو بالا ببرد....
                </Text>
                <Button>
                    <a style={{ color: "white" }} href='/why-ebus'>
                        بیشتر...
                    </a>
                </Button>
            </Left>
        </Container>
    )
}

export default GoToWhyEbusLanding;
